import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ProgressBar, Card } from 'shared/components';

import './ChecklistCard.scss';

const completedSubs = children => children
  .filter(child => child.completedDateTime);

const ChecklistCard = (props) => {
  const { t } = useTranslation();
  let progressProps = {};

  if (!props.task.children) {
    progressProps = {
      maxValue: 1,
      current: props.task.completedDateTime ? 1 : 0,
      total: 1,
      labelAddon: t('common.labels.completed'),
      showIncomplete: !props.task.completedDateTime,
    };
  } else {
    progressProps = {
      maxValue: props.task.children.length,
      current: completedSubs(props.task.children).length,
      total: props.task.children.length,
      showNumbersReport: true,
      labelAddon: t('common.labels.completed'),
    };
  }

  const children = (
    <div className="task-content">
      <p className="fw-bold text-navy mb-0">{props.task.name}</p>
      <ProgressBar {...progressProps} />
    </div>
  );

  return (
    <Card small={props.small} className={`${props.isActive ? 'active' : ''} checklist-card`}>
      {props.isActive ? (
        <Link
          to={`/test-event/${props.eventId}/event-checklist/${props.task.taskId}`}
          href={`/test-event/${props.eventId}/event-checklist/${props.task.taskId}`}
        >
          {children}
          <i className="material-icons md-48 chevron text-pacific-blue">chevron_right</i>
        </Link>) :
        children
      }
    </Card>
  );
};

export default ChecklistCard;

ChecklistCard.propTypes = {
  eventId: PropTypes.number.isRequired,
  task: PropTypes.shape({}).isRequired,
  small: PropTypes.bool,
  isActive: PropTypes.bool,
};

ChecklistCard.defaultProps = {
  small: false,
  isActive: true,
};